<template>
  <div>
      <h2>Gantt_new</h2>
    <DiagramG style="margin-top: 0px" ref="diagram">
      <template v-slot:bottoni>
        <section v-if="diagram != null">
          <v-btn
            :color="diagram.selected == 0 ? 'var(--accent)' : 'lightgrey'"
            class="mr-2"
            @click="diagram.switchView(0), (diagram.selected = 0)"
            ><span
              :style="
                diagram.selected == 0 ? 'color:white' : 'color:var(--accent)'
              "
            >
              Mezz'ore</span
            >
          </v-btn>
          <v-btn
            :color="diagram.selected == 1 ? 'var(--accent)' : 'lightgrey'"
            class="mr-2"
            @click="diagram.switchView(1), (diagram.selected = 1)"
            ><span
              :style="
                diagram.selected == 1 ? 'color:white' : 'color:var(--accent)'
              "
              >Ore</span
            ></v-btn
          >
          <v-btn
            :color="diagram.selected == 2 ? 'var(--accent)' : 'lightgrey'"
            class="mr-2"
            @click="diagram.switchView(2), (diagram.selected = 2)"
            ><span
              :style="
                diagram.selected == 2 ? 'color:white' : 'color:var(--accent)'
              "
              >Turni</span
            ></v-btn
          >
          <v-btn
            :color="diagram.selected == 3 ? 'var(--accent)' : 'lightgrey'"
            class="mr-2"
            @click="diagram.switchView(3), (diagram.selected = 3)"
            ><span
              :style="
                diagram.selected == 3 ? 'color:white' : 'color:var(--accent)'
              "
            >
              Giorni
            </span>
          </v-btn>
          <v-btn
            :color="diagram.selected == 4 ? 'var(--accent)' : 'lightgrey'"
            class="mr-2"
            @click="diagram.switchView(4), (diagram.selected = 4)"
            ><span
              :style="
                diagram.selected == 4 ? 'color:white' : 'color:var(--accent)'
              "
            >
              Settimane
            </span>
          </v-btn>
          <v-btn
            :color="diagram.selected == 5 ? 'var(--accent)' : 'lightgrey'"
            class="mr-2"
            @click="diagram.switchView(5), (diagram.selected = 5)"
          >
            <span
              :style="
                diagram.selected == 5 ? 'color:white' : 'color:var(--accent)'
              "
            >
              Mesi
            </span>
          </v-btn>
          <v-btn
            :color="diagram.selected == 6 ? 'var(--accent)' : 'lightgrey'"
            class="mr-2"
            @click="diagram.switchView(6), (diagram.selected = 6)"
            ><span
              :style="
                diagram.selected == 6 ? 'color:white' : 'color:var(--accent)'
              "
            >
              Anni
            </span>
          </v-btn>
          <v-btn class="mr-2" @click="salva" small>
            <v-icon color="success"> mdi-floppy </v-icon>
          </v-btn>
          <v-btn
            class="mr-2"
            @click="diagram.deleteDB()"
            onClick="document.location.reload(true)"
          >
            <span style="color: grey">Annulla modifiche</span>
          </v-btn>
        </section>
      </template>
    </DiagramG>
  </div>
</template>
<script>

import DiagramG from "@/components/GANTT_NEW/DiagramG.vue";
import alasql from "alasql";
export default {
  name: "Gantt_new",
  components: { DiagramG },
  props: {},
  data() {
    return {
      // Variabili d'appoggio
      // Modal
      dialog_wo: true,
      diagram: null,
      // Array
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {
    apriDialogWO() {
      console.log("entrato apri WO");
      this.dialog_wo = true;
    },

    chiudiDialogWO() {
      this.dialog_wo = false;
    },

    dropDB() {
      let that=this;
      if (this.$refs.diagram.CALENDAR.db_connection != null) {
        this.$refs.diagram.CALENDAR.db_connection.close();
        this.$refs.diagram.CALENDAR.db_connection = null;
      }
      console.log("entrato drop db", this.$refs.diagram.CALENDAR);
      try {
        var DBDeleteRequest = window.indexedDB.deleteDatabase("commessa_db");
        DBDeleteRequest.onerror = function () {
          console.log("Error deleting database.");
        };

        DBDeleteRequest.onsuccess = function () {
          console.log("Database deleted successfully");
          that.$refs.diagram.getJsonDalServer();
        };
      } catch (error) {
        console.log("errore ", error);
      }
    },

    async salva() {
      let task_modificati = new Array();

        await new Promise((resolve) => {
            alasql(`ATTACH INDEXEDDB DATABASE commessa_db; \
            SELECT * FROM commessa_db.Task WHERE modificato = 1`, [], function (res) {

                task_modificati = (res[1]);
                //console.log("risultato query" + res);

                resolve();
            });
        });

        console.log("Task modificati query");
        console.log(task_modificati);
      const arr_tmp = task_modificati;
      const request = {
        controller: "Schedulatore",
        method: "POST",
        richiesta: {
          action: "saveTask",
          token: localStorage.user_token,
          task: arr_tmp,
        },
      };

      // Inserisco un overlay di caricamento.
      this.caricamento_dati = true;

      this.$store
        .dispatch("api", request)
        .then((res) => {
          // Tolgo l'overlay di caricamento.
          this.caricamento_dati = false;

          if (res.status === 200) {
            this.$emit("inviati_wo");

            // Stampo una snackbar di conferma.
          }
        })
        .catch((err) => {
          // Tolgo l'overlay di caricamento.
          this.caricamento_dati = false;

          // Stampo una snackbar di avviso.
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );

          // Stampo il log dell'errore in console.
          console.error(err);
        });
        await new Promise((resolve) => {
            alasql(`ATTACH INDEXEDDB DATABASE commessa_db; \
            UPDATE commessa_db.Task SET modificato = null`, [], function () {
                resolve();
            });
        });
    },
  },
  created() {},
  mounted() {
    this.diagram = this.$refs.diagram;
    console.log(this.$refs);
  },
};
</script>
<style scoped>
</style>